export const Logo = ({ size = "md" }) => {
  const dims = {
    sm: "text-3xl",
    md: "text-4xl",
    lg: "text-5xl",
  }[size];

  return (
    <span className="inline-flex items-baseline font-serif font-medium text-zinc-900 tracking-wide select-none" data-testid="vira-logo">
      <span className={dims}>V</span>
      <span className={`relative ${dims}`}>
        ı
        <span className="absolute left-1/2 -translate-x-1/2 top-[0.06em] w-[0.2em] h-[0.2em] rounded-full bg-[#E80071]" aria-hidden="true" />
      </span>
      <span className={dims}>Ra</span>
    </span>
  );
};
